import React from 'react'
import { useTranslation } from 'react-i18next'
import { Control, FieldErrors, useWatch } from 'react-hook-form'
import { Typography } from '@material-ui/core'
import { ControlledTextField } from '../../../form/ControlledTextField'
import { validators } from '../../../../validation/validators'
import { InternalFormValues } from '../form-values'
import { FormGroup } from '../../../form/FormGroup'
import { temperatureUnit } from '../../../../util/formatters'
import { ControlledSwitch } from '../../../form/ControlledSwitch'

type Props = {
  control: Control<InternalFormValues>
  errors: FieldErrors<InternalFormValues>
}

export function WaterCoolingHeatPumpForm({
  control,
  errors,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const freeCooling = useWatch<boolean>({
    control,
    name: 'parameters.waterCoolingHeatPump.freeCooling',
  })

  return (
    <>
      <FormGroup>
        <ControlledTextField
          control={control}
          name="parameters.waterCoolingHeatPump.eer"
          rules={{
            ...validators.required,
            ...validators.eer,
          }}
          error={errors.parameters?.waterCoolingHeatPump?.eer}
          label={t('createProvider.forms.waterCoolingHeatPump.eer')}
          defaultValue="4"
        />
      </FormGroup>

      <FormGroup>
        <ControlledSwitch
          control={control}
          name="parameters.waterCoolingHeatPump.freeCooling"
          label={t('createProvider.forms.waterCoolingHeatPump.freeCooling')}
        />
      </FormGroup>

      {freeCooling && (
        <>
          <FormGroup>
            <ControlledTextField
              control={control}
              name="parameters.waterCoolingHeatPump.freeCoolingMaxOutdoorTemperature"
              rules={{
                ...validators.required,
                ...validators.decimal,
              }}
              error={
                errors.parameters?.waterCoolingHeatPump
                  ?.freeCoolingMaxOutdoorTemperature
              }
              label={t(
                'createProvider.forms.waterCoolingHeatPump.freeCoolingMaxOutdoorTemperature',
              )}
              InputProps={{
                endAdornment: <Typography>{temperatureUnit}</Typography>,
              }}
              defaultValue="10"
            />
          </FormGroup>

          <FormGroup>
            <ControlledTextField
              control={control}
              name="parameters.waterCoolingHeatPump.freeCoolingEer"
              rules={{
                ...validators.required,
                ...validators.eer,
              }}
              error={errors.parameters?.waterCoolingHeatPump?.freeCoolingEer}
              label={t(
                'createProvider.forms.waterCoolingHeatPump.freeCoolingEer',
              )}
              defaultValue="10"
            />
          </FormGroup>
        </>
      )}
    </>
  )
}
